module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "hero page-unknown"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container page-header"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_c('h1', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  })]), _vm._v(" Page not found")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n              Sorry but the page you requested doesn't exist.\n            ")])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('video', {
    attrs: {
      "autoplay": "",
      "loop": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "https://i.imgur.com/a0voxPE.mp4",
      "type": "video/mp4"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc69dcce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Unknown.vue
// module id = 174
// module chunks = 1